export const news = {
  newsFeedCreateInputPlaceholder: 'Parašykite įrašą...',
  newsFeedSearchInputPlaceholder: 'Ieškoti',
  newsFeedPostOwnerCurtainEditTitle: 'Redaguoti įrašą',
  newsFeedPostOwnerCurtainDeleteTitle: 'Ištrinti įrašą',
  newsFeedEditedPostSavedAlertText: 'Įrašas išsaugotas!',
  newsFeedEditedPostDeletedAlertText: 'Įrašas ištrintas!',
  newsFeedShareCurtainOptionTitle: 'Kopijuoti nuorodą',
  newsFeedPostLinkCopiedAlertText: 'Nuoroda nukopijuota!',
  newsFeedOthersPostCurtainOptionCopyTitle: 'Kopijuoti nuorodą',
  newsFeedOthersPosLinkCopiedAlertText: 'Nuoroda nukopijuota!',
  newsFeedOthersPostCurtainOptionFlagTitle: 'Pažymėti turinį',
  newsFeedOtherPostOwnersCurtainDeleteTitle: 'Ištrinti įrašą',
  newsFeedPostDeletePopupTitle: 'Ištrinti',
  newsFeedPostDeletePopupText: 'Ištrinti šį įrašą?',
  newsFeedPostDeletePopupCancelButtonTitle: 'Atšaukti',
  newsFeedPostDeletePopupConfirmButtonTitle: 'Patvirtinti',
  newsFeedPostDeeletedAlertText: 'Įrašas ištrintas!',
  newsPostDetailsHeaderTitle: 'Įrašas',
  postFeedPostLikesText: 'Patinka',
  postFeedPostCommentsText: 'Komentarai',
  postFeedPostNoLikesText: 'Dar nėra patikimų',
  postFeedPostLeaveFirstLikeText: 'Galite palikti pirmąjį',
  newsFeedPostDetailsNoCommentsText: 'Dar nėra komentarų',
  newsFeedPostDetailsFirstCommentText: 'Galite palikti pirmą komentarą',
  newsFeedPostDetailsShareOptionTitle: 'Kopijuoti nuorodą',
  newsFeedPostDetailsSharePostCopiedAlertText: 'Nuoroda nukopijuota!',
  newsFeedPostDetailsUsersCurtainCopyOptionTitle: 'Kopijuoti nuorodą',
  newsFeedPostDetailsCopiedAlertText: 'Nuoroda nukopijuota!',
  newsFeedPostDetailsUsersCurtainFlagOptionTitle: 'Pažymėti turinį',
  newsPostDetailsFlagCurtainOptionSpamTitle: 'Pažymėti',
  newsPostDetailsReportedCurtainText: 'Turinys pažymėtas',
  newsPostDetailsCommentOwnerCurtainEditOptionTitle: 'Redaguoti komentarą',
  newsPostDetailsCommentOwnerCurtainDeleteOptionTitle: 'Ištrinti komentarą',
  newsPostDetailsEditedCommentSavedAlertText: 'Komentaras išsaugotas!',
  postDetailsOtherCommentAppOwnerCurtainOptionTitle: 'Ištrinti komentarą',
  postDetailsOtherUsersCommentDeletadAlertText: 'Komentaras ištrintas!',
  postDetailsDeleteCommentPopupTitle: 'Ištrinti',
  postDetailsDeleteCommentPopupText: 'Ištrinti šį komentarą?',
  postDetailsDeleteCommentPopupCancelButtonTitle: 'Atšaukti',
  postDetailsDeleteCommentPopupConfirmlButtonTitle: 'Patvirtinti',
  postDetailsCommDeletedAlertText: 'Komentaras ištrintas!',
  postDetailsCommentUserCurtainOptionTitle: 'Pažymėti komentarą',
  newsCreatePostCurtainTitle: 'Naujas įrašas',
  newsCreatePostCurtainBodyPlaceholder: 'Įrašykite tekstą čia...',
  newsCreatePostPublishButtonTitle: 'Paskelbti',
  newsCreatePostUploadSlallerImageAlertText: 'Vienu metu galite įkelti ne daugiau nei {size} MB',
  newsPostSavedAlertText: 'Įrašas išsaugotas!',
  newsCreatePostAddLocationCurtainTitle: 'Vieta',
  newsCreatePostAddLocationCurtainInputPlaceholder: 'Vietos pavadinimas',
  newsCreatePostEditLocationCurtainText: 'Redaguoti vietą',
  newsDeleteLocation: 'Ištrinti vietą',
  newsDiscardPostPopupTitle: 'Juodraštis',
  newsDiscardPostPopupText: 'Atmesti šį juodraštį?',
  newsDiscardPostPopupCancelButtonTitle: 'Atšaukti',
  newsDiscardPostPopupCofirmButtonTitle: 'Patvirtinti',
  newsNewPostCreatePollTitle: 'Sukurti apklausą',
  newsNewPostCreatePollTitleInputPlaceholder: 'Pavadinimas',
  newsNewPostCreatePollOptionInputPlaceholder: 'Pasirinkimas',
  newsNewPostCreatePollAddButtonTitle: 'Pridėti pasirinkimą',
  newsNewPostCreatePollCreateButtonTitle: 'Sukurti',
  newsCreatePostPollTitleBlankAlertText: 'Pavadinimas negali būti tuščias!',
  newsCreatePostPollOptionBlankAlertText: 'Pasirinkimas negali būti tuščias!',
  newsCreatePostPollLongTitleAlertText: 'Pavadinimas gali turėti daugiausia {length} simbolių',
  newsCreatePostPollLongOptionAlertText: 'Pasirinkimas gali turėti daugiausia {length} simbolių',
  newsCreatePostPollEditOptionTitle: 'Redaguoti apklausą',
  newsCreatePostPollRemoveOptionTitle: 'Pašalinti apklausą',
  newsPostPollInfoVotesText: 'balsai',
  newsPostPollInfoEditVoteText: 'Redaguoti balsą',
  newsPostPollFinishPollText: 'Užbaigti apklausą',
  newsPostPollFinishedPollText: 'Užbaigta',
  newsPostPollInProgresslText: 'Vyksta',
  newsFinishPollCurtainTitle: 'Užbaigti apklausą',
  newsFinishPollCurtainText: 'Baigus apklausą, vartotojai nebegalės balsuoti.',
  newsFinishPollCurtainCancelButtonTitle: 'Atšaukti',
  newsFinishPollCurtainConfirmlButtonTitle: 'Patvirtinti',
  newsPollInfoPollVotesCurtainTitle: 'Apklausos balsai',
  newsEditPostCurtainTitle: 'Redaguoti įrašą',
  newsEditPostCurtainNoTextBodyPlaceholder: 'Įrašykite tekstą čia...',
  newsEditPostCurtainSaveButtonTitle: 'Išsaugoti',
  newsEditPostSavedAlertText: 'Įrašas išsaugotas!',
  newsError: 'Įvyko klaida!',
  newsAt: 'prie',
  newsSeeMore: 'Žiūrėti daugiau...',
  newsMaxAttachments: 'Viršijote maksimalų priedų skaičių. Maksimalus priedų skaičius: {length}',
  newsReply: 'Atsakyti',
  newsPin: 'Prisegti įrašą',
  newsUnpin: 'Atsegti įrašą'
}
